var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-dialog",
    {
      attrs: { color: "secondary", cancel: true, "prevent-close": "" },
      scopedSlots: _vm._u([
        {
          key: "buttons",
          fn: function(props) {
            return [
              _c("q-btn", {
                attrs: { label: _vm.$t("cancel"), flat: "" },
                on: {
                  click: function($event) {
                    _vm.handleCancel(props.cancel)
                  }
                }
              }),
              _c("q-btn", {
                attrs: {
                  label: _vm.$t("ok"),
                  disabled: !_vm.hasDiscount,
                  flat: ""
                },
                on: {
                  click: function($event) {
                    _vm.handleAdd(props.ok)
                  }
                }
              })
            ]
          }
        }
      ]),
      model: {
        value: _vm.dialogModel,
        callback: function($$v) {
          _vm.dialogModel = $$v
        },
        expression: "dialogModel"
      }
    },
    [
      _c("span", { attrs: { slot: "title" }, slot: "title" }, [
        _vm._v(_vm._s(_vm.$t("cash_discount_dialog_header")))
      ]),
      _c("span", {
        attrs: { slot: "message" },
        domProps: { innerHTML: _vm._s(_vm.$t("cash_discount_dialog_content")) },
        slot: "message"
      }),
      _c(
        "div",
        { attrs: { slot: "body" }, slot: "body" },
        [
          _c("q-field", { staticClass: "q-field-force-input" }, [
            _c(
              "div",
              { staticClass: "row items-end no-wrap" },
              [
                _c("q-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate.disbale",
                      value: "required",
                      expression: "'required'",
                      modifiers: { disbale: true }
                    }
                  ],
                  staticClass: "col-auto",
                  staticStyle: { width: "100px" },
                  attrs: { name: "discount", type: "number", suffix: "%" },
                  model: {
                    value: _vm.cashDiscount.amount,
                    callback: function($$v) {
                      _vm.$set(_vm.cashDiscount, "amount", $$v)
                    },
                    expression: "cashDiscount.amount"
                  }
                }),
                _c("div", { staticClass: "col text-center" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("cash_discount_payment_until")))
                  ])
                ]),
                _c("q-datetime", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate.disbale",
                      value: "required",
                      expression: "'required'",
                      modifiers: { disbale: true }
                    }
                  ],
                  staticClass: "col-auto",
                  attrs: {
                    type: "date",
                    name: "cashDiscountLimit",
                    "hide-underline": "",
                    format: _vm.$t("date_format")
                  },
                  model: {
                    value: _vm.cashDiscount.dateLimit,
                    callback: function($$v) {
                      _vm.$set(_vm.cashDiscount, "dateLimit", $$v)
                    },
                    expression: "cashDiscount.dateLimit"
                  }
                })
              ],
              1
            )
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }